var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 95,
    viewBox: "0 0 80 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4407 50.2867C67.1844 48.7886 65.1597 48.7886 63.9033 50.2867L42.3324 76.0094C41.0761 77.5075 41.0761 79.9219 42.3324 81.42C42.9605 82.1691 43.7986 82.5024 44.6361 82.5024C45.4735 82.5024 46.3116 82.1696 46.9398 81.42L68.5107 55.6973C69.6974 54.1992 69.6975 51.7854 68.4407 50.2867Z",
    fill: "#0EA5E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5695 53.8662C50.5695 57.3142 48.2253 60.1096 45.3338 60.1096C42.4424 60.1096 40.0981 57.3142 40.0981 53.8662C40.0981 50.4176 42.4424 47.6228 45.3338 47.6228C48.2253 47.6228 50.5695 50.4176 50.5695 53.8662Z",
    fill: "#0EA5E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.674 77.8401C70.674 81.288 68.3298 84.0834 65.4383 84.0834C62.5468 84.0834 60.2026 81.288 60.2026 77.8401C60.2026 74.3921 62.5468 71.5967 65.4383 71.5967C68.3298 71.5967 70.674 74.3921 70.674 77.8401Z",
    fill: "#0EA5E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.477 39.9642L53.0824 34.8032C53.4316 33.7208 52.7333 32.5554 51.7559 32.5554H21.3192C16.4327 32.5554 12.3837 36.8843 11.8948 42.7113L10.6385 56.5301C10.4987 57.8622 11.2666 59.1106 12.3837 59.444C13.64 59.7767 15.3157 60.027 16.9912 60.2767L18.0381 82.2534C18.1078 84.0847 19.4342 85.4999 20.9701 85.4999H29.836C31.3718 85.4999 32.6281 84.0848 32.768 82.2534L34.3739 44.4601C34.3739 42.5456 35.7004 41.0469 37.2362 41.0469H50.1509C50.7786 41.0469 51.2675 40.6306 51.4769 39.9646L51.477 39.9642Z",
    fill: "#0EA5E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2116 17.9041C35.2116 24.2943 30.867 29.4751 25.5081 29.4751C20.1488 29.4751 15.8047 24.2943 15.8047 17.9041C15.8047 11.5138 20.1488 6.33301 25.5081 6.33301C30.867 6.33301 35.2116 11.5138 35.2116 17.9041Z",
    fill: "#0EA5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/Conversion.0d9c306d65f430f94575114c7662f27d.svg";
export { ForwardRef as ReactComponent };